import { cdnAssetUrl, publicAssetUrl } from "../../config/staticAssets";

export const DOWNLOAD_LINKS = {
  android: "https://play.google.com/store/apps/details?id=com.welinkjobs&hl=en&pli=1",
  androidQr: publicAssetUrl("Default/WelinkJobs Android App.png"),
  ios: "https://apps.apple.com/in/app/welinkjobs/id6446752605",
  iosQr: publicAssetUrl("Default/WelinkJobs iOS App.png"),
  introVideo: publicAssetUrl("video.mp4"),
  hotlinePhone: "tel:+13072436345",
  hotlineDisplay: "+1 3072436345",
  whatsapp: "https://wa.me/+966505504880",
};

export const STORE_BADGES = {
  googlePlay: cdnAssetUrl("assets/img/icon/googleplay.svg"),
  appStore: cdnAssetUrl("assets/img/icon/applestore.svg"),
};

export const FEATURE_CARDS = [
  {
    title: "Company Profiles:",
    text: "Employers can create detailed profiles to attract potential candidates",
    icon: cdnAssetUrl("assets/img/icon/srv_01.svg"),
  },
  {
    title: "Resume Building:",
    text: "Tools and templates to help users create professional resumes",
    icon: cdnAssetUrl("assets/img/icon/srv_03.svg"),
  },
  {
    title: "Job Alerts:",
    text: "Personalized job alerts based on user preferences and search history",
    icon: cdnAssetUrl("assets/img/icon/srv_02.svg"),
  },
  {
    title: "Networking:",
    text: "Opportunities to connect with industry professionals and other job seekers",
    icon: cdnAssetUrl("assets/img/icon/srv_04.svg"),
  },
  {
    title: "Interview Preparation:",
    text: "Resources and tips to help users prepare for job interviews",
    icon: cdnAssetUrl("assets/img/icon/srv_05.svg"),
  },
  {
    title: "Application Tracking:",
    text: "Tools to help users keep track of their job applications and their status.",
    icon: cdnAssetUrl("assets/img/icon/srv_06.svg"),
  },
];
